module.exports = __webpack_public_path__ + "media/images/screen-shot-2021-02-10-at-2-23-1-7@2x-dce98134500081ea40fdd23d2905d64b.png";